import { useEffect, useState } from 'react';
import base from '../apis';
import { URL } from '../constants';

/**
 *
 * @param {string} url
 * @returns data, isloading and error message associated if any
 */
function useFetch(url) {
	const [isLoading, setIsLoading] = useState(false);
	const [data, setData] = useState(null);
	const [error, setError] = useState(null);

	useEffect(() => {
		const controller = new AbortController();
		setIsLoading(true);
		setData(null);
		setError(null);
		base
			.get(url, {
				URL,
				signal: controller.signal,
			})
			.then(({ data }) => {
				setData(data);
				setError(null);
				setIsLoading(false);
			})
			.catch((err) => {
				setIsLoading(false);
				setError('An Error occured');
			});

		return () => {
			controller.abort();
		};
	}, [url]);

	return { isLoading, data, error };
}

export default useFetch;
